import { SignatureField } from '@/types/documents';

export interface FieldTypeConfig {
  color: string;
  bgColor: string;
  bgColorLight: string;
  label: string;
  testLabel: string;
  defaultWidth: number;
  defaultHeight: number;
  minScreenW: number;
  minScreenH: number;
}

export const FIELD_CONFIG: Record<string, FieldTypeConfig> = {
  signature: {
    color: '#e53e3e',
    bgColor: 'rgba(229, 62, 62, 0.1)',
    bgColorLight: 'rgba(229, 62, 62, 0.08)',
    label: 'Signature',
    testLabel: 'Sign Here',
    defaultWidth: 200,
    defaultHeight: 60,
    minScreenW: 100,
    minScreenH: 30,
  },
  date: {
    color: '#3182ce',
    bgColor: 'rgba(49, 130, 206, 0.1)',
    bgColorLight: 'rgba(49, 130, 206, 0.08)',
    label: 'Date',
    testLabel: 'Date',
    defaultWidth: 150,
    defaultHeight: 20,
    minScreenW: 50,
    minScreenH: 15,
  },
  name: {
    color: '#38a169',
    bgColor: 'rgba(56, 161, 105, 0.1)',
    bgColorLight: 'rgba(56, 161, 105, 0.08)',
    label: 'Name',
    testLabel: 'Name',
    defaultWidth: 180,
    defaultHeight: 25,
    minScreenW: 60,
    minScreenH: 18,
  },
};

export const FIELD_TYPES = Object.keys(FIELD_CONFIG) as Array<
  keyof typeof FIELD_CONFIG
>;

export function getFieldConfig(fieldType: string): FieldTypeConfig {
  return FIELD_CONFIG[fieldType] || FIELD_CONFIG.signature;
}

export function getFieldCounts(
  fields: SignatureField[],
): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const f of fields) {
    counts[f.field_type] = (counts[f.field_type] || 0) + 1;
  }
  return counts;
}

export function formatFieldCounts(fields: SignatureField[]): string {
  const counts = getFieldCounts(fields);
  const parts: string[] = [];
  for (const type of FIELD_TYPES) {
    if (counts[type] > 0) {
      parts.push(`${counts[type]} ${FIELD_CONFIG[type].label.toLowerCase()}`);
    }
  }
  return parts.join(', ');
}

export function formatFieldSummaryByPage(fields: SignatureField[]): string {
  const byPage: Record<number, SignatureField[]> = {};
  for (const f of fields) {
    if (!byPage[f.page]) byPage[f.page] = [];
    byPage[f.page].push(f);
  }
  const pages = Object.keys(byPage)
    .map(Number)
    .sort((a, b) => a - b);
  return pages
    .map((p) => `Page ${p}: ${formatFieldCounts(byPage[p])}`)
    .join(' | ');
}
